// extracted by mini-css-extract-plugin
module.exports = {"post":"Post_post__acRqJ","post__container":"Post_post__container__KcCqe","post__additional":"Post_post__additional__QH5__"};